<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <!-- avec la piqure -->
    <div v-if="hasPiqure">
      <div class="soigante-container">
        <div v-show="step == 1">
          <div class="row">
            <div class="col-md-8">
              <div class="right-soignante">
                <p>Bonjour, vous venez pour vos démangeaisons de chenilles ?</p>
                <div class="arrowright"></div>
              </div>
              <div class="right-soignante">
                <p>
                  Ah, vous cherchez aussi du propane liquide ?! Quelle drôle de requête ! Écoutez, ici c’est un hôpital,
                  on ne distribue pas ce genre de substances comme ça… Et puis, j'ai beaucoup de patients à gérer, je
                  n’ai pas vraiment le temps de m’occuper de ça ! Heureusement qu’on a été prévoyant·es et qu’on a tenu
                  à avoir autant de lits ! Quand je pense qu’on nous disait que 200 lits pour 25 000 jeunes, c’était
                  trop,… Eh bien, ils doivent être bien contents maintenant !
                </p>
                <div class="arrowright"></div>
              </div>
              <div class="right-soignante">
                <p>
                  Bon, par contre c’est vrai qu’on a moins chauffé que prévu. On a encore pas mal de propane. Je
                  pourrais vous en laisser une petite bouteille si vous y tenez. Mais je veux être sûre que vous en avez
                  assez dans la caboche pour l’utiliser correctement ! Tenez, regardez sur l’étagère : je vous donne
                  quelques indices et on va bien voir ! Si vous vous retrouvez avec de l’eau salée ou de la soupe
                  d’orties, tant pis.
                </p>
                <div class="arrowright"></div>
              </div>
              <div class="object" v-on:click="step += 1">Relever le défi</div>
            </div>
            <div class="col-md-4">
              <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/soignante.svg" height="400px" />
            </div>
          </div>
        </div>
        <div v-show="step == 2">
          <div class="row">
            <div class="col-md-1 hopital-clue-col"></div>
            <div class="col-md-2 hopital-clue-col">
              <div class="hopital-clue">
                <p>
                  Devant toi s’alignent des fioles, Une seule pourra t’aider, Les autres sont des babioles, Alors reste
                  concentré·e.
                </p>
              </div>
            </div>
            <div class="col-md-2 hopital-clue-col">
              <div class="hopital-clue">
                <p>
                  Une seule fiole contient, Le liquide pour lequel tu viens, Trois sont des eaux salées Et peuvent être
                  colorés, Deux des remèdes utiles, Deux de l'ortie futile
                </p>
              </div>
            </div>
            <div class="col-md-2 hopital-clue-col">
              <div class="hopital-clue">
                <p>
                  Le propane est stocké hermétique, Dans une fiole unique, Cette substance convoitée, Se trouve près de
                  l'eau salée, Qui d'une couleur dorée, N'a pas été teintée,
                </p>
              </div>
            </div>
            <div class="col-md-2 hopital-clue-col">
              <div class="hopital-clue">
                <p>
                  L'ortie n'a subi, tu t’en doutes, Pas d’autre transformation, Qu'une simple réduction, Pour en faire
                  de la soupe,
                </p>
              </div>
            </div>
            <div class="col-md-2 hopital-clue-col">
              <div class="hopital-clue">
                <p>
                  Les remèdes précieux, Sont cachés quant à eux, Dans des petits flacons Qui assurent leur conservation
                </p>
              </div>
            </div>
            <div class="col-md-1 hopital-clue-col"></div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <div class="row" style="height: 60%; width: max-content; margin: auto;">
                <div v-for="n in 8" :key="n" @click="select = n" class="fioles-div">
                  <img
                    v-if="n != select"
                    :class="'fioles_' + n"
                    :src="'https://cdn.exploreve.fr/content/cluedo/Fioles/fiole_' + n + '.svg'"
                  />
                  <img
                    v-else
                    :class="'select-fiole fioles_' + n"
                    :src="'https://cdn.exploreve.fr/content/cluedo/Fioles/fiole_' + n + '.svg'"
                  />
                </div>
              </div>
              <div class="row" style="height: 15%;">
                <div v-if="error" class="error">
                  <p>Mauvaise réponse ! Réeessaye.</p>
                </div>
              </div>
              <div class="row" style="height: 15%;">
                <div class="object" v-on:click="validGame()">Valider mon choix</div>
              </div>
            </div>
            <div class="col-md-2">
              <img class="soignante" src="https://cdn.exploreve.fr/content/cluedo/soignante.svg" height="400px" />
            </div>
          </div>
        </div>
        <div v-show="step == 3">
          <div class="row">
            <div class="col-md-8">
              <div style="width: max-content; margin: auto;">
                <img
                  class="final-fiole"
                  :src="'https://cdn.exploreve.fr/content/cluedo/Fioles/fiole_' + select + '.svg'"
                />
              </div>
              <div class="object" v-on:click="$emit('close')">Récupérer le propane</div>
            </div>
            <div class="col-md-4">
              <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/soignante.svg" height="400px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- sans la piqure -->
    <div v-else>
      <div class="slideshow-container">
        <div class="mySlides"></div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-5">
            <div class="right">
              <p>C’est un hôpital ici ! On y entre que si on a une bonne raison ! Allez, ouste !</p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-4">
            <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/soignante.svg" height="400px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.final-fiole {
  height: 350px;
}
.select-fiole {
  border: 3px solid #5e2a57;
  border-radius: 5px;
}
.fioles_1 {
  height: 100px;
}
.fioles_2 {
  height: 150px;
}
.fioles_3 {
  height: 75px;
}
.fioles_4 {
  height: 75px;
}
.fioles_5 {
  height: 110px;
}
.fioles_6 {
  height: 75px;
}
.fioles_7 {
  height: 75px;
}
.fioles_8 {
  height: 100px;
}

.fioles-div {
  display: flex;
  height: 100%;
  align-items: flex-end;
  padding: 10px;
}
.error {
  font-family: Faune;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  margin: auto;
  color: #a5190e;
}
.soignante {
  height: 300px;
}
.soigante-container {
  width: 1100px;
  height: 500px;
  position: relative;
  margin: auto;
}
.hopital-clue {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  background: #ffffff;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.hopital-clue-col {
  padding-right: 5px;
  padding-left: 5px;
}
.right-soignante {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  max-width: 600px;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
  padding-right: 0px;
  margin-right: 10px;
  margin-left: auto;
}

/* .row {
  width: 1100px !important;
} */
</style>
<script>
export default {
  props: {
    hasPiqure: Boolean
  },
  data: function () {
    return {
      step: 1,
      select: 0,
      error: false
    };
  },
  methods: {
    validGame: function () {
      if (this.select == 2) {
        this.$emit("recupObject", "propane");
        this.step++;
      } else {
        this.error = true;
      }
    }
  }
};
</script>
